<template>
  <AppPreloader v-if="vacancies.isFetching" />
  <VAlert
    v-else-if="vacancies.fetchError"
    type="error"
  >
    {{ vacancy.fetchError }}
  </VAlert>
  <div v-else-if="vacancies.items.length === 0">
    <div class="d-flex flex-column justify-center align-center my-md-10">
      <VIcon x-large class="my-5 grey--text">
        {{ mdiBriefcase }}
      </VIcon>
      <span>{{ $t('noVacancies') }}</span>
    </div>
  </div>
  <div v-else>
    <div v-show="isMobile">
      <CompanyVacanciesList
        :vacancies="filteredVacancies"
        :company-id="companyId"
      />
    </div>
    <div v-show="!isMobile">
      <CompanyVacanciesTable
        :vacancies="filteredVacancies"
        :company-id="companyId"
      />
    </div>
    <div />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mdiBriefcase } from '@mdi/js';
import AppPreloader from '../AppPreloader.vue';
import CompanyVacanciesTable from './CompanyVacanciesTable.vue';
import CompanyVacanciesList from './CompanyVacanciesList.vue';

export default {
  name: 'CompanyVacanciesContainer',
  components: { CompanyVacanciesTable, CompanyVacanciesList, AppPreloader },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
    exclude: {
      type: Number,
      required: false,
      default: -1,
    },
    limit: {
      type: Number,
      required: false,
      default: -1,
    },
  },
  data() {
    return {
      mdiBriefcase,
    };
  },
  computed: {
    ...mapState('company', ['vacancies']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    filteredVacancies() {
      let vacancies = this.vacancies.items;
      const { exclude, limit } = this;
      if (exclude > -1) {
        vacancies = vacancies.filter(item => item.id !== exclude);
      }

      return (limit > -1) ? vacancies.slice(0, limit) : vacancies;
    },
  },
  async serverPrefetch() {
    await this.fetch();
  },
  async mounted() {
    if (!this.vacancies.isFetched && !this.vacancies.isFetching) {
      await this.fetch();
    }
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('company/fetchVacancies', this.companyId);
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  noVacancies: No Jobs yet
</i18n>

<i18n locale="ru" lang="yaml">
  noVacancies: Вакансий пока нет
</i18n>
